import React from 'react';
import '../../styles/IndustryUseCases.css';

interface UseCase {
  icon: string;
  title: string;
  description: string;  
  features?: string[];
}

interface IndustryUseCasesProps {
  title?: string;
  subtitle?: string;
  useCases: UseCase[];
}

const IndustryUseCases: React.FC<IndustryUseCasesProps> = ({
  title = "Industries & Use Cases We Specialize In",
  subtitle = "We bring domain-aware cost optimization strategies tailored to your cloud workloads, business models, and team structures.",
  useCases
}) => {
  return (
    <section className="industry-use-cases">
      <div className="industry-use-cases-content">
        <div className='industry-use-cases-header'>
          <h2 className='I-heading'>{title}</h2>
          <p className="subtitle">{subtitle}</p>
        </div>
        <div className="use-cases-grid-f">
          {useCases.map((useCase, index) => (
            <div key={index} className="use-case-segment">
              <div className="use-case-content">
                <div>
                  <span className="industry-card-number-idc">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <h3 className="use-case-title">{useCase.title}</h3>
                  <p className="use-case-description">{useCase.description}</p>
                </div>
                <div className="all-features-row">
                {useCase.features && useCase.features.length > 0 && (
                  <ul className="use-case-features">
                    {useCase.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="use-case-feature">
                        {feature}
                      </li>
                    ))}
                  </ul>
                )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustryUseCases;
